/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { CalendarViews } from '../../enum/calendar-views.enum';
import { CalendarCell } from './calendar-cell';

import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/fr';
import 'dayjs/locale/en';
import 'dayjs/locale/nl.js';
import { TranslateService } from '@ngx-translate/core';

export class CalendarViewMonth {
  currentDate: Dayjs;
  cells: CalendarCell[] = [];
  public type: CalendarViews;
  firstDate: Dayjs;
  endDate: Dayjs;

  constructor(date: Date, translator: TranslateService) {
    dayjs.locale('fr');
    this.type = CalendarViews.month;
    translator.onLangChange.subscribe((lang) => {
      dayjs.locale(lang.lang);
    });
    this.currentDate = dayjs(date);
    this.setFirstDate();
    this.setEndDate();
  }

  setFirstDate(): void {
    this.firstDate = this.currentDate.clone().startOf('month');
  }

  setEndDate(): void {
    this.endDate = this.currentDate.clone().endOf('month');
  }

  generateCells(): CalendarCell[] {
    const month = this.firstDate.get('month');
    let date = this.firstDate.clone();
    const cells: CalendarCell[] = [];
    while (date.get('month') === month) {
      cells.push(new CalendarCell(date));
      date = date.clone().add(1, 'd');
    }
    return cells;
  }
}
